PayAnywhereWinAnimator = {};
PayAnywhereWinAnimator.animationPool = [];
PayAnywhereWinAnimator.currentAnimations = [];
PayAnywhereWinAnimator.winBoxYTweak = 0;
PayAnywhereWinAnimator.symbolwinOffsetX = 0;
PayAnywhereWinAnimator.symbolwinOffsetY = -0;
PayAnywhereWinAnimator.gameReels = undefined;
PayAnywhereWinAnimator.justWilds = false;

PayAnywhereWinAnimator.offsetY = -10;

PayAnywhereWinAnimator.ready = false;
PayAnywhereWinAnimator.ignorePopups = false;
PayAnywhereWinAnimator.presentingScatterWins = false;

PayAnywhereWinAnimator.playScatterSymbolAnimationsResolver = null;
PayAnywhereWinAnimator.playScatterSymbolAnimationsPromise = null;

PayAnywhereWinAnimator.lowWinSounds = ['winLow_0', 'winLow_1', 'winLow_2'];
PayAnywhereWinAnimator.lastRandomLowWinSoundIndex = -1;
PayAnywhereWinAnimator.highWinSounds = ['winHigh_0', 'winHigh_1', 'winHigh_2'];
PayAnywhereWinAnimator.lastRandomLowWinSoundIndex = -1;

PayAnywhereWinAnimator.initialise = function () {
  PayAnywhereWinAnimator.symbolInfo = resourceManager.getConfiguration().symbols;
  PayAnywhereWinAnimator.symbolInfoKeys = Object.keys(PayAnywhereWinAnimator.symbolInfo);

  PayAnywhereWinAnimator.animationContainer = resourceManager.get('slotContainer:foregroundReelSymbols');
  PayAnywhereWinAnimator.scatterSymbolAnimationContainer = resourceManager.get(
    'slotContainer:scatterSymbolAnimationContainer'
  );
  PayAnywhereWinAnimator.winPopupTextContainer = resourceManager.get('slotContainer:winPopupTextContainer');

  PayAnywhereWinAnimator.animationPool = [
    {
      poolName: 'BlueBeanWin_md',
      number: 0,
      pool: [],
    },
    {
      poolName: 'GreenBeanWin_md',
      number: 0,
      pool: [],
    },
    {
      poolName: 'PurpleBeanWin_md',
      number: 0,
      pool: [],
    },
    {
      poolName: 'RedBeanWin_md',
      number: 0,
      pool: [],
    },
    {
      poolName: 'YellowBeanWin_md',
      number: 0,
      pool: [],
    },
    {
      poolName: 'GreenGemWin_md',
      number: 0,
      pool: [],
    },
    {
      poolName: 'PurpleGemWin_md',
      number: 0,
      pool: [],
    },
    {
      poolName: 'RedGemWin_md',
      number: 0,
      pool: [],
    },
    {
      poolName: 'YellowGemWin_md',
      number: 0,
      pool: [],
    },
    {
      poolName: 'WildWin_md',
      number: 0,
      pool: [],
    },
    {
      poolName: 'BonusWin_md',
      number: 0,
      pool: [],
    },
    {
      poolName: 'GoldenEggSmallWin_md',
      number: 0,
      pool: [],
    },
    {
      poolName: 'GoldenEggLargeWin_md',
      number: 0,
      pool: [],
    },
    {
      poolName: 'WildPrePop_md',
      number: 0,
      pool: [],
    },
  ];

  for (let k = 0; k < PayAnywhereWinAnimator.animationPool.length; k++) {
    const name = PayAnywhereWinAnimator.animationPool[k].poolName;
    for (let i = 0; i < 8; i++) {
      PayAnywhereWinAnimator.createAnim(name, i, k);
    }
  }

  PayAnywhereWinAnimator.gameReels = gameData.reels;

  // need to create a winTextPopup for each symbol position
  PayAnywhereWinAnimator.winTextPopups = [];
  for (let reel = 0; reel < 6; reel++) {
    PayAnywhereWinAnimator.winTextPopups[reel] = [];
    for (let row = 0; row < 5; row++) {
      const id = 'WinTextPopup_reel' + reel + '_row' + row;
      const data = {
        id: id,
        reel: reel,
        row: row,
        textData: {
          ID: id,
        },
      };
      if (row === 0) {
        // values on the top row dont move up so far
        data.yOffset = -50;
      }
      PayAnywhereWinAnimator.winTextPopups[reel][row] = new WinTextPopup(data);
    }
  }

  PayAnywhereWinAnimator.ready = true;

  messageBus.subscribe('spinner:SpinEvent', PayAnywhereWinAnimator.doSpin);
  messageBus.subscribe('spinner:ReSpinEvent', PayAnywhereWinAnimator.doSpin);
};

PayAnywhereWinAnimator.doSpin = function (spinTask) {
  PayAnywhereWinAnimator.reels = spinTask.data.resultPanel.reelList;
};

PayAnywhereWinAnimator.createAnim = function (name, index, poolIndex = undefined) {
  let anim = undefined;

  // if (name === 'symbolWin_md') {
  //   anim = resourceManager.createObject('movie', name + '_' + index, 'slotContainer:symbolWinBorderAnim', {
  //     definition: name,
  //     anchor: 0.5,
  //   });
  // } else {
  anim = resourceManager.createObject('movie', name + '_' + index, 'slotContainer:foregroundReelSymbols', {
    definition: name,
    anchor: 0.5,
  });
  // }

  // we really shouldnt have these in the container until needed
  anim.parent.removeChild(anim);

  anim.loop = false;
  anim.gotoAndStop(0);
  anim.visible = false;

  if (poolIndex === undefined) {
    for (let i = 0; i < PayAnywhereWinAnimator.animationPool.length; i++) {
      let poolType = PayAnywhereWinAnimator.animationPool[i];

      if (poolType.poolName === name) {
        poolType.pool.push(anim);
        poolType.number++;
      }
    }
  } else {
    PayAnywhereWinAnimator.animationPool[poolIndex].pool.push(anim);
    PayAnywhereWinAnimator.animationPool[poolIndex].number++;
  }

  return anim;
};

PayAnywhereWinAnimator.positionAnim = function (animationObject) {
  const reels = PayAnywhereWinAnimator.gameReels;
  const anim = animationObject.anim;
  const reel = animationObject.reel;
  const row = animationObject.row;

  const x = reels[reel].position.getX();
  const y = reels[reel].position.getY() + row * reels[reel].Props.appertureSpacing;

  anim.position.set(x, y);

  // also take the opportunity to position the winTextPopups
  // we wont show all of them per win, just one, but we may as well update them all
  PayAnywhereWinAnimator.winTextPopups[reel][row].setXY(x, y);
};

PayAnywhereWinAnimator.winTextPopupNextToAnother = function (newReel, newRow) {
  let nextTo = false;
  for (let i = 0; i < PayAnywhereWinAnimator.requiredWinTextPopups.length; i++) {
    const row = PayAnywhereWinAnimator.requiredWinTextPopups[i].getRow();
    const reel = PayAnywhereWinAnimator.requiredWinTextPopups[i].getReel();
    if (row === newRow && (reel - 1 === newReel || reel + 1 === newReel)) {
      // we will be next to another win text popup
      nextTo = true;
      break;
    }
  }
  return nextTo;
};

PayAnywhereWinAnimator.pickWinTextPopupForWin = function (win, isCapped = false) {
  // there must be a much easier / cleaner / safer way of checking this
  let winTextPopup = null;
  let abort = false;

  let topRow = 0;
  let ignoreNextTo = false;
  do {
    // 1st lets pick the middle symbol
    const middleIndex = Math.floor(win.winSymPositions.length / 2);
    const { sym: middleSym, reel: middleReel, row: middleRow } = win.winSymPositions[middleIndex];

    if (
      middleSym !== 9 && // 9 is a wild
      middleRow !== topRow &&
      PayAnywhereWinAnimator.winTextPopupNextToAnother(middleReel, middleRow) === false
    ) {
      // middle index isnt a 9 so thats a good easy start
      // also we arent along the top row
      // and we arent next to someone else
      winTextPopup = PayAnywhereWinAnimator.winTextPopups[middleReel][middleRow];
      winTextPopup.setValue(win.baseWin, isCapped);
    } else {
      // go from middle up
      for (let i = middleIndex + 1; i < win.winSymPositions.length; i++) {
        const winSymPosition = win.winSymPositions[i];
        const { sym, reel, row } = winSymPosition;
        if (
          sym !== 9 &&
          row !== topRow &&
          PayAnywhereWinAnimator.winTextPopupNextToAnother(reel, row) === ignoreNextTo
        ) {
          // this isnt a wild and we arent along the top row
          winTextPopup = PayAnywhereWinAnimator.winTextPopups[reel][row];
          winTextPopup.setValue(win.baseWin, isCapped);
          break;
        }
      }

      if (winTextPopup === null) {
        // we are still looking
        // go from middle down
        for (let i = middleIndex - 1; i >= 0; i--) {
          const winSymPosition = win.winSymPositions[i];
          const { sym, reel, row } = winSymPosition;
          if (
            sym !== 9 &&
            row !== topRow &&
            PayAnywhereWinAnimator.winTextPopupNextToAnother(reel, row) === ignoreNextTo
          ) {
            // this isnt a wild and we arent along the top row
            winTextPopup = PayAnywhereWinAnimator.winTextPopups[reel][row];
            winTextPopup.setValue(win.baseWin, isCapped);
            break;
          }
        }
      }

      if (winTextPopup === null) {
        if (topRow === -1) {
          // we have already tried ignoring top row
          // should we ignore next to
          if (ignoreNextTo === false) {
            ignoreNextTo = true;
          } else {
            console.log('error with winTextPopup');
            abort = true;
          }
        }
        topRow = -1;
        // give up keeping the text off the top row
      }
    }
  } while (winTextPopup === null && !abort);

  return winTextPopup;
};

PayAnywhereWinAnimator.animate = function (data, callback, singleWinCallback) {
  PayAnywhereWinAnimator.wins = [];
  PayAnywhereWinAnimator.requiredWinTextPopups = [];
  PayAnywhereWinAnimator.highestSymbol = 0;
  PayAnywhereWinAnimator.justWilds = data.justWilds;

  if (gameController.winSkipped() === true) {
    // was skip win already pressed
    // assuming this is because of skipping magic beans anim
    callback();
    return;
  }

  let wins = [];

  if (data.payWaysLeft.payWaysWins.length > 0) {
    wins.push(...data.payWaysLeft.payWaysWins);
  }

  wins.forEach(function (win) {
    const winSymbol = win.symbol;
    if (winSymbol > PayAnywhereWinAnimator.highestSymbol) {
      PayAnywhereWinAnimator.highestSymbol = winSymbol;
    }

    if (PayAnywhereWinAnimator.justWilds === false) {
      const winTextPopup = PayAnywhereWinAnimator.pickWinTextPopupForWin(win, data.isCapped);
      if (winTextPopup !== null) {
        PayAnywhereWinAnimator.requiredWinTextPopups.push(winTextPopup);
      } else {
        // something went wrong, just dont show a pop up text and let the game carry on
      }
    }

    win.winSymPositions.forEach(function (symbol) {
      if (PayAnywhereWinAnimator.justWilds === false || symbol.sym === 9) {
        // check for dupes
        let isADupe = false;
        for (let i = 0; i < PayAnywhereWinAnimator.wins.length && !isADupe; i++) {
          if (
            PayAnywhereWinAnimator.wins[i].reel === symbol.reel &&
            PayAnywhereWinAnimator.wins[i].row === symbol.row
          ) {
            isADupe = true;
          }
        }
        if (isADupe === false) {
          PayAnywhereWinAnimator.wins.push(symbol);
        }
      }
    });
  });

  for (let i = 0; i < reelManager.reels.length; i++) {
    reelManager.reels[i].dimAllSymbols(true, 0x666666);
  }

  PayAnywhereWinAnimator.singleWinCallback = singleWinCallback;

  PayAnywhereWinAnimator.finishedCallback = callback;

  if (PayAnywhereWinAnimator.justWilds === true) {
    soundManager.play('wildActivate');
  } else {
    if (data.winAmount >= gameController.globalHelperGetBaseStake() * 2) {
      // high win audio
      PayAnywhereWinAnimator.playHighWinSound();
    } else {
      // low win audio
      PayAnywhereWinAnimator.playLowWinSound();
    }
  }

  PayAnywhereWinAnimator.animateNextWin();
};

PayAnywhereWinAnimator.playLowWinSound = function () {
  let randomIndex = -1;
  let goes = 5;
  do {
    randomIndex = game.randomNumberBetween(0, PayAnywhereWinAnimator.lowWinSounds.length - 1);
  } while (randomIndex === PayAnywhereWinAnimator.lastRandomLowWinSoundIndex && --goes > 0);
  soundManager.play(PayAnywhereWinAnimator.lowWinSounds[randomIndex]);
  PayAnywhereWinAnimator.lastRandomLowWinSoundIndex = randomIndex;
};

PayAnywhereWinAnimator.playHighWinSound = function () {
  let randomIndex = -1;
  let goes = 5;
  do {
    randomIndex = game.randomNumberBetween(0, PayAnywhereWinAnimator.highWinSounds.length - 1);
  } while (randomIndex === PayAnywhereWinAnimator.lastRandomHighWinSoundIndex && --goes > 0);
  soundManager.play(PayAnywhereWinAnimator.highWinSounds[randomIndex]);
  PayAnywhereWinAnimator.lastRandomHighWinSoundIndex = randomIndex;
};

PayAnywhereWinAnimator.animateSymbolWithoutBorder = function (
  symMovieName,
  reel,
  row,
  container = PayAnywhereWinAnimator.animationContainer
) {
  let animation = PayAnywhereWinAnimator.findAnimation(symMovieName);

  let animationObject = {
    anim: animation,
    reel: reel,
    row: row,
    symbolIndex: 0,
  };

  container.addChild(animation);
  PayAnywhereWinAnimator.currentAnimations.push(animationObject);

  animation.onComplete = function () {
    PayAnywhereWinAnimator.animationFinished(animationObject);
    PayAnywhereWinAnimator.returnToPool(symMovieName, animation);
  };

  PayAnywhereWinAnimator.positionAnim(animationObject);

  animation.visible = true;
  animation.gotoAndPlay(0);

  return animationObject;
};

PayAnywhereWinAnimator.animateSymbol = function (
  symMovieName,
  reel,
  row,
  container = PayAnywhereWinAnimator.animationContainer
) {
  let animation = PayAnywhereWinAnimator.findAnimation(symMovieName);

  let animationObject = {
    anim: animation,
    reel: reel,
    row: row,
    symbolIndex: 0,
  };

  container.addChild(animation);
  PayAnywhereWinAnimator.currentAnimations.push(animationObject);

  animation.onComplete = function () {
    gameData.reels[reel].showSymbol(row, true);
    PayAnywhereWinAnimator.animationFinished(animationObject);
    PayAnywhereWinAnimator.returnToPool(symMovieName, animation);
  };

  PayAnywhereWinAnimator.positionAnim(animationObject);

  let playWinAnim = true;
  if (playWinAnim) {
    gameData.reels[reel].showSymbol(row, false);
    animation.visible = true;
    animation.gotoAndPlay(0);
  }

  return animationObject;
};

PayAnywhereWinAnimator.findAnimation = function (symMovieName) {
  let animation = undefined;
  let location = 0;
  let number = 0;

  for (let i = 0; i < PayAnywhereWinAnimator.animationPool.length; i++) {
    let poolType = PayAnywhereWinAnimator.animationPool[i];

    if (poolType.poolName === symMovieName) {
      number = poolType.number;
      location = i;

      if (poolType.pool.length > 0) {
        animation = poolType.pool[0];
        poolType.pool.splice(0, 1);
        return animation;
      }
    }
  }

  animation = PayAnywhereWinAnimator.createAnim(symMovieName, number + 1);
  PayAnywhereWinAnimator.animationPool[location].pool.pop();
  return animation;
};

PayAnywhereWinAnimator.returnToPool = function (name, animation) {
  for (let i = 0; i < PayAnywhereWinAnimator.animationPool.length; i++) {
    let poolType = PayAnywhereWinAnimator.animationPool[i];

    if (poolType.poolName === name) {
      poolType.pool.push(animation);
    }
  }
};

PayAnywhereWinAnimator.animateNextWin = function () {
  const symbolInfo = PayAnywhereWinAnimator.symbolInfo;

  if (PayAnywhereWinAnimator.currentAnimations.length > 0) {
    PayAnywhereWinAnimator.skip();
  }

  /*
  // doesnt work this way for this game
  const highestSymInfoId = PayAnywhereWinAnimator.symbolInfoKeys.find(function (key) {
    return PayAnywhereWinAnimator.highestSymbol === symbolInfo[key].ID;
  });
  soundManager.play(symbolInfo[highestSymInfoId].soundFile);
  */

  const symbolKeys = PayAnywhereWinAnimator.symbolInfoKeys;
  PayAnywhereWinAnimator.currentAnimations = [];
  PayAnywhereWinAnimator.wins.forEach(function (symbol) {
    let symbolName = symbolKeys[symbol.sym] + 'Win_md';
    if (PayAnywhereWinAnimator.justWilds === true) {
      symbolName = symbolKeys[symbol.sym] + 'PrePop_md';
    }

    reelManager.reels[symbol.reel].dimSymbol(symbol.row, false);

    const animationObject = PayAnywhereWinAnimator.animateSymbol(symbolName, symbol.reel, symbol.row);
    animationObject.symbolIndex = symbol.sym;
  });

  // now handle draw order, e.g. magic beans should be last so drawn over any other animation
  PayAnywhereWinAnimator.updateDrawOverForSymbols(PayAnywhereWinAnimator.currentAnimations);
};

PayAnywhereWinAnimator.showAllWinTextPopups = function () {
  for (let i = 0; i < PayAnywhereWinAnimator.requiredWinTextPopups.length; i++) {
    PayAnywhereWinAnimator.requiredWinTextPopups[i].show();
  }
};

PayAnywhereWinAnimator.updateDrawOverForSymbols = function (symbols) {
  const symbolIdsDrawOrder = [9];

  for (let s = 0; s < symbolIdsDrawOrder.length; s++) {
    for (let l = 0; l < symbols.length; l++) {
      if (symbols[l].symbolIndex === symbolIdsDrawOrder[s]) {
        const parent = symbols[l].anim.parent;
        parent.removeChild(symbols[l].anim);
        parent.addChild(symbols[l].anim);
      }
    }
  }
};

PayAnywhereWinAnimator.animationFinished = function (animationObject) {
  if (animationObject !== undefined) {
    animationObject.anim.gotoAndStop(0);
    animationObject.anim.visible = false;
    animationObject.anim.parent.removeChild(animationObject.anim);
    PayAnywhereWinAnimator.currentAnimations.splice(
      PayAnywhereWinAnimator.currentAnimations.indexOf(animationObject),
      1
    );
  }

  if (PayAnywhereWinAnimator.currentAnimations.length === 0) {
    // no more animations in the array, do we have any promises that need resolving?
    if (PayAnywhereWinAnimator.playScatterSymbolAnimationsResolver) {
      PayAnywhereWinAnimator.playScatterSymbolAnimationsResolver();
      PayAnywhereWinAnimator.playScatterSymbolAnimationsResolver = null;
    }

    if (PayAnywhereWinAnimator.finishedCallback) {
      PayAnywhereWinAnimator.finishedCallback();
    }

    // anims finished, show win text popups
    if (!PayAnywhereWinAnimator.justWilds && !PayAnywhereWinAnimator.ignorePopups) {
      // assuming the pop will occur straight after
      // i want to keep this here as its this object / class which creates the pop ups
      PayAnywhereWinAnimator.showAllWinTextPopups();
    }
  }

  if (PayAnywhereWinAnimator.singleWinCallback) {
    PayAnywhereWinAnimator.singleWinCallback();
  }

  if (PayAnywhereWinAnimator.currentAnimations.length === 0) {
    for (let i = 0; i < reelManager.reels.length; i++) {
      reelManager.reels[i].dimAllSymbols(false, 0x666666);
    }
  }
};

PayAnywhereWinAnimator.skip = function () {
  for (let i = PayAnywhereWinAnimator.currentAnimations.length - 1; i >= 0; i--) {
    PayAnywhereWinAnimator.currentAnimations[i].anim.onComplete();
  }

  for (let i = 0; i < PayAnywhereWinAnimator.requiredWinTextPopups.length; i++) {
    PayAnywhereWinAnimator.requiredWinTextPopups[i].skip();
  }
  PayAnywhereWinAnimator.requiredWinTextPopups = [];
};

PayAnywhereWinAnimator.onOrientationChange = function () {
  if (PayAnywhereWinAnimator.ready) {
    PayAnywhereWinAnimator.currentAnimations.forEach((animationObject) => {
      PayAnywhereWinAnimator.positionAnim(animationObject);
    });
  }
};

PayAnywhereWinAnimator.presentScatterWin = async function () {
  PayAnywhereWinAnimator.presentingScatterWins = true;

  await PayAnywhereWinAnimator.playScatterSymbolAnimations(true);

  PayAnywhereWinAnimator.presentingScatterWins = false;
};

PayAnywhereWinAnimator.hasPresentScatterWinsFinished = function () {
  const result = !PayAnywhereWinAnimator.presentingScatterWins;
  return result;
};

PayAnywhereWinAnimator.playScatterSymbolAnimations = async function (ignorePopups = true) {
  PayAnywhereWinAnimator.ignorePopups = ignorePopups;

  PayAnywhereWinAnimator.playScatterSymbolAnimationsResolver = null;
  PayAnywhereWinAnimator.playScatterSymbolAnimationsPromise = new Promise((resolve) => {
    PayAnywhereWinAnimator.playScatterSymbolAnimationsResolver = resolve;
  });

  soundManager.play('bonusWon');

  const bonusID = resourceManager.getConfiguration().symbols['Bonus'].ID;
  for (let i = 0; i < reelManager.reels.length; i++) {
    for (let j = 0; j < reelManager.reels[i].symbolData.length; j++) {
      if (reelManager.reels[i].symbolData[j].symbolId === bonusID) {
        gameData.reels[i].showSymbol(j, false);
        PayAnywhereWinAnimator.animateSymbolWithoutBorder(
          'BonusWin_md',
          i,
          j,
          PayAnywhereWinAnimator.scatterSymbolAnimationContainer
        );
      }
    }
  }

  await PayAnywhereWinAnimator.playScatterSymbolAnimationsPromise;

  for (let i = 0; i < reelManager.reels.length; i++) {
    for (let j = 0; j < reelManager.reels[i].symbolData.length; j++) {
      if (reelManager.reels[i].symbolData[j].symbolId === bonusID) {
        gameData.reels[i].showSymbol(j, true);
      }
    }
  }

  PayAnywhereWinAnimator.ignorePopups = false;
};

PayAnywhereWinAnimator.onReady = function () {
  // PayAnywhereWinAnimator.ready = true;
};

Reflex.registerEventHandler('layoutChange', PayAnywhereWinAnimator.onOrientationChange);
Reflex.registerEventHandler('ready', PayAnywhereWinAnimator.onReady);
